import { useParams } from "react-router-dom";
import Programs from "../components/Programs/Programs";

const ProgramsDynamicPage = () => {
  const { id } = useParams();

  return <Programs pageId={id} />;
};

export default ProgramsDynamicPage;
